import React, { useReducer } from 'react';
import MarcaContext from './marcaContext';
import MarcaReducer from './marcaReducer';

import clienteAxios from '../../service/axios';

import {
    OBTENER_MARCAS,
    AGREGAR_MARCA,
    ELIMINAR_MARCA,
    ACTUALIZAR_MARCA,
    MARCA_ERROR,
    MARCA_OK,
    MARCA_ACTUAL,
    OBTENER_MARCA,
} from 'types/context';

const MarcaState = props => {
    const initialState = {
        marcas: [], // grupos del cliente
        marca: null,
        cliente: null,
        formulario: false,
        errorformulario: false,
        mensaje: null
    }

    const [state, dispatch] = useReducer(MarcaReducer, initialState);

    const host = process.env.REACT_APP_BACKEND_URL || 'https://app.dev.pampa4.ar:4000'
    const obtenerMarcas = async () => {
        try {
            // siempre deberia venir un cliente
            let resultado = await clienteAxios.get(`/marcas`);
            const tempArr = []

            if (resultado?.data?.marcas?.rows != null) {
                resultado.data.marcas.rows.map(marca => {
                    tempArr.push({
                        ...marca,
                        logo: host + marca.file?.path
                    })
                })
            }
            //

            dispatch({
                type: OBTENER_MARCAS,
                payload: tempArr
            });
            return tempArr
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
        }
    }

    // Agregar nuevo grupo
    const agregarMarca = async (marca) => {
        
        try {
            const resultado = await clienteAxios.post('/marcas', marca);

            // Insertar el grupo en el estado
            dispatch({
                type: AGREGAR_MARCA,
                payload: resultado.data.marca
            })
            const alerta = {
                msg: "Marca agregada con exito",
                categoria: 'exito'
            }
            dispatch({
                type: MARCA_OK,
                payload: alerta
            })
            return resultado.status
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }

            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
            return alerta
        }
    }
    // Selecciona el grupo que el usuario dio click
    const marcaActual = marcaId => {
        dispatch({
            type: MARCA_ACTUAL,
            payload: marcaId
        })
    }

    // Elimina una marca
    const eliminarMarca = async marcaId => {
        try {
            await clienteAxios.delete(`/marcas/${marcaId}`);
            dispatch({
                type: ELIMINAR_MARCA,
                payload: marcaId
            })
            const alerta = {
                msg: "Marca eliminado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: MARCA_OK,
                payload: alerta
            })
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }

            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
        }
    }
    const validateUrl = (url) => {

        let urlFixed
        if (url.split(":")[0] !== "http" || url.split(":")[0] !== "https") {
            urlFixed = "https://" + url
        }
        return urlFixed ? urlFixed : url
    }
    // Aactualizar grupo
    const actualizarMarca = async marca => {

        try {
            const resultado = await clienteAxios.put(`/marcas/${marca.id}`, marca );

            // Actualizo el disp en el state
            dispatch({
                type: ACTUALIZAR_MARCA,
                payload: resultado.data.marca
            })
            const alerta = {
                msg: "Marca editado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: MARCA_OK,
                payload: alerta
            })
            return resultado.status
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }

            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
            return alerta
        }
    }

    // muestra un error de validacion
    const errorMarca = (msj, categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }
        dispatch({
            type: MARCA_ERROR,
            payload: alerta
        })
    }
    const OkMarca = (msj, categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }
        dispatch({
            type: MARCA_OK,
            payload: alerta
        })
    }
    const clearErrorMarca = () => {
        dispatch({
            type: MARCA_ERROR,
            payload: null,
        });
    };

    const clearOkMarca = () => {
        dispatch({
            type: MARCA_OK,
            payload: null,
        });
    };

    // Obtengo un grupo por id
    const obtenerMarca = async (marcaId) => {
        const tempArr = []
        let tempMarca
        try {

            const resultado = await clienteAxios.get(`/marcas?id=${marcaId}`);
            if ( resultado?.data?.marcas?.rows != null) {
                const marca = resultado?.data?.marcas?.rows
                if ( marca.length > 0 ) {
                    tempMarca = {
                        ...marca[0],
                        logo: host + marca[0].file?.path
                    }
                }
            }
            dispatch({
                type: OBTENER_MARCA,
                payload: tempMarca
            })
            return tempMarca;

        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
        }
    }

    return (
        <MarcaContext.Provider
            value={{
                marcas: state.marcas,
                marca: state.marca,
                cliente: state.cliente,
                formulario: state.formulario,
                errorformulario: state.errorformulario,
                mensaje: state.mensaje,
                obtenerMarcas,
                agregarMarca,
                marcaActual,
                clearErrorMarca,
                clearOkMarca,
                eliminarMarca,
                actualizarMarca,
                errorMarca,
                OkMarca,
                obtenerMarca,
            }}
        >{props.children}

        </MarcaContext.Provider>
    )
}
export default MarcaState;
